const c = {
  name: "Hands10001",
  dimensions: { width: 35, height: 34 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 35 34" style="enable-background:new 0 0 35 34;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M27,4.4C27,2.1,28.7,0,31,0s4,2.1,4,4.4V15h-2V4.4C33,3,32,2,31,2s-2,1-2,2.4v4.9h-0.1C29,9.5,29,9.8,29,10v7
			c0,2.2-1.8,4-4,4c-1.2,0-2.3-0.5-3-1.4c-0.7,0.8-1.8,1.4-3,1.4c-1.2,0-2.2-0.5-3-1.3c-0.7,0.8-1.8,1.3-3,1.3c-1.6,0-3-0.9-3.7-2.3
			l-3.8-4l0,0c-0.7-0.9-2-1-2.8-0.2c-0.9,0.7-1,2-0.2,2.8l1.9,2.3l6.7,7.5C13.9,30.2,17.8,32,22,32c6.1,0,11-4.9,11-11v-6h2v6
			c0,7.2-5.8,13-13,13c-4.7,0-9.3-2-12.4-5.6l-6.7-7.5l-1.9-2.3c-1.4-1.7-1.2-4.2,0.5-5.6c1.7-1.4,4.2-1.2,5.6,0.5l2,2.1V9.8
			C9,7.6,10.9,6,13,6c0.8,0,1.6,0.2,2.2,0.6C15.8,5.1,17.3,4,19,4c1.7,0,3.2,1.1,3.8,2.7C23.4,6.2,24.2,6,25,6c0.7,0,1.4,0.2,2,0.5
			V4.4z M19,6c-1.1,0-2,0.9-2,2v9c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2V8C21,6.9,20.1,6,19,6z M23,10v7c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2
			v-7c0-1.1-0.9-2-2-2C23.9,8,23,8.9,23,10z M13,8c1.2,0,2,0.9,2,1.8v7.4c0,0.9-0.8,1.8-2,1.8s-2-0.9-2-1.8V9.8C11,8.9,11.8,8,13,8z
			"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Hands10001
};
